












































import { Vue, Component, Prop } from 'vue-property-decorator';
import utils from '@/services/utils';
import AuthModule from '@/store/modules/Auth';
import { getModule } from 'vuex-module-decorators';

@Component
export default class StatementBody extends Vue {
  AuthInstance = getModule(AuthModule, this.$store);

  @Prop() readonly data!: object;

  @Prop() readonly sum!: number;

  @Prop() readonly paginationDetail!: object;

  utilsInstance = utils;

  isAdmin = ['SUPERADMIN', 'ADMIN'].includes(this.AuthInstance.user.role)
}
